import React from 'react';
import Pneuma from './Pneuma';

function App() {
  return (
    <div className="App">
      <Pneuma />
    </div>
  );
}

export default App;